import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91ae2516"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-z-50 tw-flex tw-items-center tw-justify-between tw-border-b tw-bg-white tw-py-4 tw-pl-5 tw-pr-4 dark:tw-bg-black" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-gap-3" }
const _hoisted_3 = { class: "dark:tw-text-white" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 1,
  class: "tw-flex tw-space-x-2"
}
const _hoisted_6 = { class: "tw-flex tw-h-full tw-flex-col tw-overflow-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cross = _resolveComponent("Cross")!
  const _component_StudioButton = _resolveComponent("StudioButton")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "opacity",
    appear: "",
    onBeforeEnter: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDrawer = true))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        "data-testid": "studio-drawer",
        class: "tw-fixed tw-inset-0 tw-z-50 tw-overflow-hidden tw-bg-white/90 dark:tw-bg-black/90",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleOutsideClick && _ctx.handleOutsideClick(...args)))
      }, [
        _createVNode(_Transition, {
          name: "fly-from-right",
          appear: "",
          onAfterLeave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('cancel')))
        }, {
          default: _withCtx(() => [
            (_ctx.showDrawer)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(`tw-fixed tw-inset-0 tw-m-2 tw-flex tw-flex-col tw-overflow-x-auto tw-rounded-xl tw-border tw-bg-white tw-shadow-[0_0_5px_5px_rgba(0,0,0,0.05)] dark:tw-bg-black dark:tw-shadow-[0_0_5px_5px_#11182766] ${
            _ctx.extraClasses ? _ctx.extraClasses : ''
          }`),
                  onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
                      _renderSlot(_ctx.$slots, "header", {}, undefined, true)
                    ]),
                    (_ctx.crossIcon)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          "data-testid": "close-studio-drawer",
                          disabled: _ctx.cancelDisabled,
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCancelClicked && _ctx.handleCancelClicked(...args)))
                        }, [
                          _createVNode(_component_Cross, { class: "tw-h-6 tw-w-6 tw-cursor-pointer dark:tw-text-white" })
                        ], 8, _hoisted_4))
                      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          (_ctx.showCancelButton)
                            ? (_openBlock(), _createBlock(_component_StudioButton, {
                                key: 0,
                                "data-testid": "cancel-studio-drawer",
                                disabled: _ctx.cancelDisabled,
                                disabledReason: _ctx.cancelButtonDisabledReason,
                                trackingId: "studio-drawer-cancel-button",
                                variant: "text",
                                onClick: _ctx.handleCancelClicked
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Cancel ")
                                ]),
                                _: 1
                              }, 8, ["disabled", "disabledReason", "onClick"]))
                            : _createCommentVNode("", true),
                          (!_ctx.hidePrimaryButton)
                            ? (_openBlock(), _createBlock(_component_StudioButton, {
                                key: 1,
                                "data-testid": "primary-studio-drawer-button",
                                disabled: _ctx.primaryButtonDisabled,
                                disabledReason: _ctx.primaryButtonDisabledReason,
                                trackingId: "studio-drawer-primary-button",
                                type: "submit",
                                variant: "filled",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('primaryButtonClick')))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.primaryButtonText), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled", "disabledReason"]))
                            : _createCommentVNode("", true)
                        ]))
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _: 3
        })
      ])
    ]),
    _: 3
  }))
}